module.exports = __webpack_public_path__ + "img/chinesecompany72.607c0ca0.png";